<script lang="ts">
  import { Colors } from '../ui/colors'
  import { Type } from '../ui/theme'

  interface Props {
    text: string
    marginBottom?: number
  }

  const { text, marginBottom = 0 }: Props = $props()
</script>

<div style="color: {Colors.textMuted}; {Type.eyebrow}; margin-bottom: {marginBottom}px;">{text}</div>
